//Generic filter
export { QFilterGeneric } from "./QFilterGeneric";

export { QFilterCustom } from "./QFilterCustom";
// /*
export { QFilterCentro } from "./QFilterCentro";
export { QFilterCentroList } from "./QFilterCentroList";
export { QFilterPK } from "./QFilterPK";
export { QFilterProcesses } from "./QFilterProcesses";
export { QFilterBP } from "./QFilterBP";
export { QFilterBPInclude } from "./QFilterBPInclude";
export { QFilterBPExclude } from "./QFilterBPExclude";
export { QFilterUnitsPage } from "./QFilterUnitsPage";
export { QFilterPage } from "./QFilterPage";
export { QFilterSearch } from "./QFilterSearch";
export { QFilterAdvanced } from "./QFilterAdvanced";
export { QFilterDateField } from "./QFilterDateField";
export { QFilterDateRange } from "./QFilterDateRange";
export { QFilterDates } from "./QFilterDates";
export { QFilterDirectories } from "./QFilterDirectories";
export { QFilterSortBy } from "./QFilterSortBy";
export { QFilterSortDesc } from "./QFilterSortDesc";
export { QFilterExcludeStates } from "./QFilterExcludeStates";
export { QFilterWorkflowResponsible } from "./QFilterWorkflowResponsible";
// */

// New explorer filters
export { QFilters } from "./QFilters"


// /*
import { QFilterCentro } from "./QFilterCentro";
import { QFilterCentroList } from "./QFilterCentroList";
import { QFilterPK } from "./QFilterPK";
import { QFilterProcesses } from "./QFilterProcesses";
import { QFilterBP } from "./QFilterBP";
import { QFilterBPInclude } from "./QFilterBPInclude";
import { QFilterBPExclude } from "./QFilterBPExclude";
import { QFilterUnitsPage } from "./QFilterUnitsPage";
import { QFilterPage } from "./QFilterPage";
import { QFilterSearch } from "./QFilterSearch";
import { QFilterAdvanced } from "./QFilterAdvanced";
import { QFilterDateField } from "./QFilterDateField";
import { QFilterDateRange } from "./QFilterDateRange";
import { QFilterDates } from "./QFilterDates";
import { QFilterDirectories } from "./QFilterDirectories";
import { QFilterSortBy } from "./QFilterSortBy";
import { QFilterSortDesc } from "./QFilterSortDesc";
import { QFilterExcludeStates } from "./QFilterExcludeStates";
import { QFilterWorkflowResponsible } from "./QFilterWorkflowResponsible";

import { QFilters } from "./QFilters"
import { QFilterGeneric } from "./QFilterGeneric";
import { QFilterCustom } from "./QFilterCustom";
// */



// Dict

const filter_dict = {

    /* Default names */
    QFilterCentro: QFilterCentro,
    QFilterCentroList: QFilterCentroList,
    QFilterPK: QFilterPK,
    QFilterProcesses: QFilterProcesses,
    QFilterBP: QFilterBP,
    QFilterBPInclude: QFilterBPInclude,
    QFilterBPExclude: QFilterBPExclude,
    QFilterUnitsPage: QFilterUnitsPage,
    QFilterPage: QFilterPage,
    QFilterSearch: QFilterSearch,
    QFilterAdvanced: QFilterAdvanced,
    QFilterDateField: QFilterDateField,
    QFilterDateRange: QFilterDateRange,
    QFilterDates: QFilterDates,
    QFilterDirectories: QFilterDirectories,
    QFilterSortBy: QFilterSortBy,
    QFilterSortDesc: QFilterSortDesc,
    QFilterExcludeStates: QFilterExcludeStates,
    QFilterWorkflowResponsible: QFilterWorkflowResponsible,

    /* From api name or similar */
    centro: QFilterCentro,
    centro_list: QFilterCentroList,
    pk: QFilterPK,
    processes_ids: QFilterProcesses,
    business_process: QFilterBP,
    business_process_include: QFilterBPInclude,
    business_process_exclude: QFilterBPExclude,
    items_per_page: QFilterUnitsPage,
    units_per_page: QFilterUnitsPage,
    page: QFilterPage,
    //offset: QFilterPage,
    search:  QFilterSearch,
    searchable_text: QFilterSearch,
    advanced_filters: QFilterAdvanced,
    date_fields: QFilterDateField,
    date_range: QFilterDateRange,
    filter_dates: QFilterDates,
    directories: QFilterDirectories,
    sort_by: QFilterSortBy,
    sort_desc: QFilterSortDesc,
    exclude_states: QFilterExcludeStates,
    workflow_responsible: QFilterWorkflowResponsible,
    current_workflow_responsible: QFilterWorkflowResponsible,
}

export { filter_dict };

// Funcio que retorni un qfilters amb les classes creades a partir d'un diccionari {api_name, value}
export function 
    url_to_filters(param) {
        let qf = new QFilters();
        if (param) {
            for (let [key, value] of Object.entries(param)) {
                const it_class = filter_dict[key];
                if (it_class) {
                    qf.set_filter(new filter_dict[key](value));
                } else {
                    qf.set_filter(new QFilterCustom(value,key));
                }
            }
        }
        return qf;
    }

export function get_qfilter(name, value) {
    const filt_class = filter_dict[name];
    if (filt_class) {
        return new filter_dict[name](value)
    } else {
        return new QFilterCustom(value,name)
    }
    
}
